import { combineReducers } from 'redux';
import { reducer as formReducer } from 'redux-form';
import previousProducts from '../../modules/previous-products/previousProductsReducer';
import login from '../../login-register/login/LoginReducer';
import register from '../../login-register/register/reducer';
import modal from '../../login-register/modal/reducer';
import app from '../../login-register/app/reducer';
import resetPassword from '../../login-register/reset-password/ResetPasswordReducer';
import estimateModal from '../../createestimate/estimateReducer';

const reducers = combineReducers({

  previousProducts,
  login,
  register,
  app,
  form: formReducer,
  modal,
  resetPassword,
  estimateModal,
});

export default reducers;
